import { concat } from '../../helpers/common'
import {
  CreateAssetPayload,
  CreateAssetSuccessPayload,
  CreateAssetFailurePayload,
  GetAssetsPayload,
  GetAssetsSuccessPayload,
  GetAssetsFailurePayload,
  CreateAssetsBatchPayload,
  CreateAssetsBatchSuccessPayload,
  CreateAssetsBatchFailurePayload,
  CreateAssetGroupPayload,
  CreateAssetGroupSuccessPayload,
  CreateAssetGroupFailurePayload,
  ApproveInternalAssetGroupPayload,
  ApproveInternalAssetGroupSuccessPayload,
  ApproveInternalAssetGroupFailurePayload,
  DisapproveInternalAssetGroupPayload,
  DisapproveInternalAssetGroupSuccessPayload,
  DisapproveInternalAssetGroupFailurePayload,
  GetAssetGroupsPayload,
  GetAssetGroupsSuccessPayload,
  GetAssetGroupsFailurePayload,
  GetAssetGroupPayload,
  GetAssetGroupSuccessPayload,
  GetAssetGroupFailurePayload,
  UpdateAssetGroupPayload,
  UpdateAssetGroupSuccessPayload,
  UpdateAssetGroupFailurePayload,
  CreateAssetGroupSignalPayload,
  CreateAssetGroupSignalSuccessPayload,
  CreateAssetGroupSignalFailurePayload
} from '../types/assets'

const MODULE_NAME = 'ASSETS/'

// PLOP_APPEND_PATTERN_ANCHOR_ACTION
export const CREATE_ASSET = concat(MODULE_NAME, 'CREATE_ASSET')
export const CREATE_ASSET_SUCCESS = concat(MODULE_NAME, 'CREATE_ASSET_SUCCESS')
export const CREATE_ASSET_FAILURE = concat(MODULE_NAME, 'CREATE_ASSET_FAILURE')
export const CLEAR_CREATE_ASSET = concat(MODULE_NAME, 'CLEAR_CREATE_ASSET')

export const GET_ASSETS = concat(MODULE_NAME, 'GET_ASSETS')
export const GET_ASSETS_SUCCESS = concat(MODULE_NAME, 'GET_ASSETS_SUCCESS')
export const GET_ASSETS_FAILURE = concat(MODULE_NAME, 'GET_ASSETS_FAILURE')
export const CLEAR_ASSETS = concat(MODULE_NAME, 'CLEAR_ASSETS')

export const CREATE_ASSETS_BATCH = concat(MODULE_NAME, 'CREATE_ASSETS_BATCH')
export const CREATE_ASSETS_BATCH_SUCCESS = concat(MODULE_NAME, 'CREATE_ASSETS_BATCH_SUCCESS')
export const CREATE_ASSETS_BATCH_FAILURE = concat(MODULE_NAME, 'CREATE_ASSETS_BATCH_FAILURE')
export const CLEAR_CREATE_ASSETS_BATCH = concat(MODULE_NAME, 'CLEAR_CREATE_ASSETS_BATCH')

export const CREATE_ASSET_GROUP = concat(MODULE_NAME, 'CREATE_ASSET_GROUP')
export const CREATE_ASSET_GROUP_SUCCESS = concat(MODULE_NAME, 'CREATE_ASSET_GROUP_SUCCESS')
export const CREATE_ASSET_GROUP_FAILURE = concat(MODULE_NAME, 'CREATE_ASSET_GROUP_FAILURE')
export const CLEAR_CREATE_ASSET_GROUP = concat(MODULE_NAME, 'CLEAR_CREATE_ASSET_GROUP')

export const APPROVE_INTERNAL_ASSET_GROUP = concat(MODULE_NAME, 'APPROVE_INTERNAL_ASSET_GROUP')
export const APPROVE_INTERNAL_ASSET_GROUP_SUCCESS = concat(MODULE_NAME, 'APPROVE_INTERNAL_ASSET_GROUP_SUCCESS')
export const APPROVE_INTERNAL_ASSET_GROUP_FAILURE = concat(MODULE_NAME, 'APPROVE_INTERNAL_ASSET_GROUP_FAILURE')
export const CLEAR_APPROVE_INTERNAL_ASSET_GROUP = concat(MODULE_NAME, 'CLEAR_APPROVE_INTERNAL_ASSET_GROUP')

export const DISAPPROVE_INTERNAL_ASSET_GROUP = concat(MODULE_NAME, 'DISAPPROVE_INTERNAL_ASSET_GROUP')
export const DISAPPROVE_INTERNAL_ASSET_GROUP_SUCCESS = concat(MODULE_NAME, 'DISAPPROVE_INTERNAL_ASSET_GROUP_SUCCESS')
export const DISAPPROVE_INTERNAL_ASSET_GROUP_FAILURE = concat(MODULE_NAME, 'DISAPPROVE_INTERNAL_ASSET_GROUP_FAILURE')
export const CLEAR_DISAPPROVE_INTERNAL_ASSET_GROUP = concat(MODULE_NAME, 'CLEAR_DISAPPROVE_INTERNAL_ASSET_GROUP')

export const GET_ASSET_GROUPS = concat(MODULE_NAME, 'GET_ASSET_GROUPS')
export const GET_ASSET_GROUPS_SUCCESS = concat(MODULE_NAME, 'GET_ASSET_GROUPS_SUCCESS')
export const GET_ASSET_GROUPS_FAILURE = concat(MODULE_NAME, 'GET_ASSET_GROUPS_FAILURE')
export const CLEAR_ASSET_GROUPS = concat(MODULE_NAME, 'CLEAR_ASSET_GROUPS')

export const GET_ASSET_GROUP = concat(MODULE_NAME, 'GET_ASSET_GROUP')
export const GET_ASSET_GROUP_SUCCESS = concat(MODULE_NAME, 'GET_ASSET_GROUP_SUCCESS')
export const GET_ASSET_GROUP_FAILURE = concat(MODULE_NAME, 'GET_ASSET_GROUP_FAILURE')
export const CLEAR_ASSET_GROUP = concat(MODULE_NAME, 'CLEAR_ASSET_GROUP')

export const UPDATE_ASSET_GROUP = concat(MODULE_NAME, 'UPDATE_ASSET_GROUP')
export const UPDATE_ASSET_GROUP_SUCCESS = concat(MODULE_NAME, 'UPDATE_ASSET_GROUP_SUCCESS')
export const UPDATE_ASSET_GROUP_FAILURE = concat(MODULE_NAME, 'UPDATE_ASSET_GROUP_FAILURE')
export const CLEAR_UPDATE_ASSET_GROUP = concat(MODULE_NAME, 'CLEAR_UPDATE_ASSET_GROUP')

export const CREATE_ASSET_GROUP_SIGNAL = concat(MODULE_NAME, 'CREATE_ASSET_GROUP_SIGNAL')
export const CREATE_ASSET_GROUP_SIGNAL_SUCCESS = concat(MODULE_NAME, 'CREATE_ASSET_GROUP_SIGNAL_SUCCESS')
export const CREATE_ASSET_GROUP_SIGNAL_FAILURE = concat(MODULE_NAME, 'CREATE_ASSET_GROUP_SIGNAL_FAILURE')
export const CLEAR_CREATE_ASSET_GROUP_SIGNAL = concat(MODULE_NAME, 'CLEAR_CREATE_ASSET_GROUP_SIGNAL')

// PLOP_APPEND_PATTERN_ANCHOR_ACTION_CREATOR

// create single asset
export function createAsset(
  assetData: {
    name: string
    [key: string]: any
  },
  isFileUploading: boolean,
  platform: string
): CreateAssetPayload {
  // isFileUploading allows to handle asset creation within the file uploading process
  // this is needed to fire action about success/error for file uploading for saga worker - createAssetWorker
  return { type: CREATE_ASSET, assetData, isFileUploading, platform }
}

export function createAssetSuccess(assetData: object): CreateAssetSuccessPayload {
  return { type: CREATE_ASSET_SUCCESS, assetData }
}

export function createAssetFailure(error: object): CreateAssetFailurePayload {
  return { type: CREATE_ASSET_FAILURE, error }
}

export function clearCreateAsset() {
  return { type: CLEAR_CREATE_ASSET }
}

// get assets
export function getAssets(params: object): GetAssetsPayload {
  return { type: GET_ASSETS, params }
}

export function getAssetsSuccess(assetsData: { results: object[]; next_page_token: string }): GetAssetsSuccessPayload {
  return { type: GET_ASSETS_SUCCESS, assetsData }
}

export function getAssetsFailure(error: object): GetAssetsFailurePayload {
  return { type: GET_ASSETS_FAILURE, error }
}

export function clearAssets() {
  return { type: CLEAR_ASSETS }
}

// create multiple assets
export function createAssetsBatch(assetsData: object[]): CreateAssetsBatchPayload {
  return { type: CREATE_ASSETS_BATCH, assetsData }
}

export function createAssetsBatchSuccess(assetsData: object[]): CreateAssetsBatchSuccessPayload {
  return { type: CREATE_ASSETS_BATCH_SUCCESS, assetsData }
}

export function createAssetsBatchFailure(error: object): CreateAssetsBatchFailurePayload {
  return { type: CREATE_ASSETS_BATCH_FAILURE, error }
}

export function clearCreateAssetsBatch() {
  return { type: CLEAR_CREATE_ASSETS_BATCH }
}

// create asset group
export function createAssetGroup(assetGroupData: object): CreateAssetGroupPayload {
  return { type: CREATE_ASSET_GROUP, assetGroupData }
}

export function createAssetGroupSuccess(assetGroupData: object): CreateAssetGroupSuccessPayload {
  return { type: CREATE_ASSET_GROUP_SUCCESS, assetGroupData }
}

export function createAssetGroupFailure(error: object): CreateAssetGroupFailurePayload {
  return { type: CREATE_ASSET_GROUP_FAILURE, error }
}

export function clearCreateAssetGroup() {
  return { type: CLEAR_CREATE_ASSET_GROUP }
}

// approve internal asset group
export function approveInternalAssetGroup(id: string): ApproveInternalAssetGroupPayload {
  return { type: APPROVE_INTERNAL_ASSET_GROUP, id }
}

export function approveInternalAssetGroupSuccess(data: object, id: string): ApproveInternalAssetGroupSuccessPayload {
  return { type: APPROVE_INTERNAL_ASSET_GROUP_SUCCESS, data, id }
}

export function approveInternalAssetGroupFailure(error: object, id: string): ApproveInternalAssetGroupFailurePayload {
  return { type: APPROVE_INTERNAL_ASSET_GROUP_FAILURE, error, id }
}

export function clearApproveInternalAssetGroup(id: string | number) {
  return { type: CLEAR_APPROVE_INTERNAL_ASSET_GROUP, id }
}

// disapprove asset group
export function disapproveInternalAssetGroup(id: string, data: object): DisapproveInternalAssetGroupPayload {
  return { type: DISAPPROVE_INTERNAL_ASSET_GROUP, id, data }
}

export function disapproveInternalAssetGroupSuccess(id: string): DisapproveInternalAssetGroupSuccessPayload {
  return { type: DISAPPROVE_INTERNAL_ASSET_GROUP_SUCCESS, id }
}

export function disapproveInternalAssetGroupFailure(
  error: object,
  id: string
): DisapproveInternalAssetGroupFailurePayload {
  return { type: DISAPPROVE_INTERNAL_ASSET_GROUP_FAILURE, error, id }
}

export function clearDisapproveInternalAssetGroup(id: string | number) {
  return { type: CLEAR_DISAPPROVE_INTERNAL_ASSET_GROUP, id }
}

// get assetsGroups
export function getAssetGroups(params: object): GetAssetGroupsPayload {
  return { type: GET_ASSET_GROUPS, params }
}

export function getAssetGroupsSuccess(assetGroupsData: { results: object[] }): GetAssetGroupsSuccessPayload {
  return { type: GET_ASSET_GROUPS_SUCCESS, assetGroupsData }
}

export function getAssetGroupsFailure(error: object): GetAssetGroupsFailurePayload {
  return { type: GET_ASSET_GROUPS_FAILURE, error }
}

export function clearAssetGroups() {
  return { type: CLEAR_ASSET_GROUPS }
}

// get assetGroup
export function getAssetGroup(params: { id: string; [key: string]: any }): GetAssetGroupPayload {
  return { type: GET_ASSET_GROUP, params }
}

export function getAssetGroupSuccess(assetGroupData: object): GetAssetGroupSuccessPayload {
  return { type: GET_ASSET_GROUP_SUCCESS, assetGroupData }
}

export function getAssetGroupFailure(error: object): GetAssetGroupFailurePayload {
  return { type: GET_ASSET_GROUP_FAILURE, error }
}

export function clearAssetGroup() {
  return { type: CLEAR_ASSET_GROUP }
}

// update assetGroup
export function updateAssetGroup(assetGroupData: object, id: string): UpdateAssetGroupPayload {
  return { type: UPDATE_ASSET_GROUP, assetGroupData, id }
}

export function updateAssetGroupSuccess(assetGroupData: object): UpdateAssetGroupSuccessPayload {
  return { type: UPDATE_ASSET_GROUP_SUCCESS, assetGroupData }
}

export function updateAssetGroupFailure(error: object): UpdateAssetGroupFailurePayload {
  return { type: UPDATE_ASSET_GROUP_FAILURE, error }
}

export function clearUpdateAssetGroup() {
  return { type: CLEAR_UPDATE_ASSET_GROUP }
}

// create asset group signal
export function createAssetGroupSignal(assetGroupSignalData: object): CreateAssetGroupSignalPayload {
  return { type: CREATE_ASSET_GROUP_SIGNAL, assetGroupSignalData }
}

export function createAssetGroupSignalSuccess(assetGroupSignalData: object): CreateAssetGroupSignalSuccessPayload {
  return { type: CREATE_ASSET_GROUP_SIGNAL_SUCCESS, assetGroupSignalData }
}

export function createAssetGroupSignalFailure(error: object): CreateAssetGroupSignalFailurePayload {
  return { type: CREATE_ASSET_GROUP_SIGNAL_FAILURE, error }
}

export function clearCreateAssetGroupSignal() {
  return { type: CLEAR_CREATE_ASSET_GROUP_SIGNAL }
}
